/**
 * @generated SignedSource<<e64fd0f8cda9b05a189de214955c77f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type homeDailyFiveContentItemContent$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "homeDailyFiveContentItemContent";
};
export type homeDailyFiveContentItemContent$key = {
  readonly " $data"?: homeDailyFiveContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"homeDailyFiveContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "homeDailyFiveContentItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "fa96d1e3136e06fb215363e6c979ac6a";

export default node;
